import type { HudState } from '../games/nganya/types';
import { EventBus, Events } from '../games/nganya/utils/EventBus';
import styles from './Hud.module.css';

interface Props {
  hud: HudState | null;
}

export function Hud({ hud }: Props) {
  if (!hud) return null;
  const hearts = Array.from({ length: hud.crashLimit }, (_, i) => i < hud.crashLimit - hud.crashes);
  const phase =
    hud.finalStretch ? 'FINAL' : hud.rushActive ? 'RUSH' : null;

  return (
    <div
      className={`${styles.hud} ${hud.rushActive ? styles.rush : ''} ${hud.finalStretch ? styles.final : ''}`}
    >
      <div className={styles.top}>
        <div className={styles.stat}>
          <span className={styles.label}>SCORE</span>
          <strong>{hud.score}</strong>
        </div>
        <div className={styles.stat}>
          <span className={styles.label}>TIME</span>
          <strong className={hud.timeLeft <= 10 || hud.finalStretch ? styles.urgent : undefined}>
            {Math.ceil(hud.timeLeft)}s
          </strong>
        </div>
        <button
          type="button"
          className={styles.pause}
          aria-label="Pause"
          onClick={() => EventBus.emit(Events.REQUEST_PAUSE)}
        >
          ❚❚
        </button>
      </div>

      <div className={styles.meta}>
        <span>Fares {hud.fares}</span>
        <span>{hearts.map((ok) => (ok ? '▮' : '▯')).join(' ')}</span>
        {hud.combo > 1 && <span className={styles.combo}>x{hud.combo}</span>}
        {hud.scoreMult > 1.05 && (
          <span className={styles.heat}>HEAT {hud.scoreMult.toFixed(2)}x</span>
        )}
        {phase && <span className={styles.phase}>{phase}</span>}
      </div>

      <div className={styles.heatBar} aria-hidden="true">
        <i style={{ width: `${Math.round(hud.heatRatio * 100)}%` }} />
      </div>

      {hud.countdown != null && hud.countdown > 0 && (
        <div className={styles.countdown} aria-live="assertive">
          {hud.countdown}
        </div>
      )}
      {hud.countdown === 0 && <div className={styles.countdown}>GO!</div>}

      <div className={styles.controls}>
        <button
          type="button"
          className={styles.ctrl}
          aria-label="Lane left"
          onPointerDown={(e) => {
            e.preventDefault();
            EventBus.emit(Events.LANE_LEFT);
          }}
        >
          ◀
        </button>
        <button
          type="button"
          className={`${styles.ctrl} ${styles.boost} ${hud.boostReady ? styles.ready : ''} ${hud.boostActive ? styles.active : ''}`}
          aria-label="Boost"
          onPointerDown={(e) => {
            e.preventDefault();
            EventBus.emit(Events.BOOST);
          }}
        >
          <span>BOOST</span>
          <i style={{ width: `${Math.round(hud.boostRatio * 100)}%` }} />
        </button>
        <button
          type="button"
          className={styles.ctrl}
          aria-label="Lane right"
          onPointerDown={(e) => {
            e.preventDefault();
            EventBus.emit(Events.LANE_RIGHT);
          }}
        >
          ▶
        </button>
      </div>
    </div>
  );
}
